module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture6-99718261bf098b4fc449aa7cf1278faf.jpg";